import { render, staticRenderFns } from "./primary-top-pane.vue?vue&type=template&id=584f5c3f&"
import script from "./primary-top-pane.vue?vue&type=script&lang=js&"
export * from "./primary-top-pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports